import React from "react";
import { Link } from "react-router-dom";

const AboutUs = () => {
  return (
    <div className="relative bg-gradient-to-br from-white via-blue-50 to-blue-100 py-20 px-4">
      {/* Optional Soft Texture Background */}
      {/*
      <div
        className="absolute inset-0 bg-cover bg-center opacity-10"
        style={{
          backgroundImage: "url('/abstract-texture.png')",
        }}
      ></div>
      */}

      {/* Content Container */}
      <div className="relative z-10 max-w-6xl mx-auto text-gray-800 space-y-16">
        {/* Title */}
        <div className="text-center">
          <h1 className="text-5xl font-bold mb-4 animate__animated animate__fadeInDown">
            About Radiant Model Academy
          </h1>
          <p className="text-xl max-w-3xl mx-auto animate__animated animate__fadeInUp text-gray-700">
            Welcome to{" "}
            <span className="text-blue-600 font-semibold">
              Radiant Model Academy
            </span>
            , where innovation meets education. We nurture curiosity, spark
            discovery, and empower young minds to shape the future with
            confidence.
          </p>
        </div>

        {/* Vision & Who We Are */}
        <div className="grid md:grid-cols-2 gap-10">
          <div className="bg-white p-6 rounded-2xl shadow-md animate__animated animate__fadeInLeft">
            <h2 className="text-2xl font-bold text-blue-700 mb-4">
              Our Vision
            </h2>
            <p className="text-lg leading-relaxed text-gray-700">
              We envision a world where education fuels progress and innovation.
              At Radiant Model Academy, students are inspired to think
              critically and creatively to drive sustainable change in society.
            </p>
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-md animate__animated animate__fadeInRight">
            <h2 className="text-2xl font-bold text-green-700 mb-4">
              Who We Are
            </h2>
            <p className="text-lg leading-relaxed text-gray-700">
              Radiant Model Academy is a vibrant community committed to raising
              future-ready leaders. With passionate educators, involved parents,
              and eager learners, we blend academic excellence with moral
              integrity, creativity, and lifelong learning.
            </p>
          </div>
        </div>

        {/* Core Values */}
        <div className="bg-white p-6 rounded-2xl shadow-md animate__animated animate__fadeInUp">
          <h2 className="text-2xl font-bold text-yellow-600 mb-4">
            Our Core Values
          </h2>
          <ul className="list-disc list-inside space-y-3 text-lg text-gray-700">
            <li>
              <strong>Innovation:</strong> We cultivate bold ideas and foster
              adaptability in a rapidly evolving world.
            </li>
            <li>
              <strong>Excellence:</strong> We commit to high standards in
              academics, character, and service.
            </li>
            <li>
              <strong>Integrity:</strong> We uphold honesty, responsibility, and
              moral courage in all we do.
            </li>
          </ul>
        </div>

        {/* Mission */}
        <div className="bg-white p-6 rounded-2xl shadow-md animate__animated animate__fadeInUp">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Our Mission</h2>
          <p className="text-lg text-gray-700 mb-6">
            To deliver a transformative education that equips students with
            critical thinking, problem-solving skills, and leadership qualities
            — empowering them to make meaningful contributions in a global
            society.
          </p>
          <Link
            to="/about"
            className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-6 py-3 rounded-xl shadow-md transition-all duration-300 hover:scale-105"
          >
            Learn More
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
